import youtubeManager from '../module/libs/youtube';

let youtube = new youtubeManager();
export default class aboutmadeinjapanManager {

    constructor() {
        this.outer = document.getElementById('p-madeinjapan__omotenashi-movie');
        this.image = document.getElementById('p-madeinjapan__omotenashi-movie-image');
        this.movie = document.getElementById('p-madeinjapan__omotenashi-movie-player');
        this.icon = this.outer.querySelector('.icon');

        this.ytFlg = false;

        TweenMax.set(this.movie,{opacity: 0});

    }

    init() {

        youtube.init('p-madeinjapan__omotenashi-movie-player', 'TTqnrWaiumg');
        this.movie = document.getElementById('p-madeinjapan__omotenashi-movie-player');

        this.outer.onclick = () => {
            TweenMax.to([this.image,this.icon],0.5,{
                opacity:0,
                display: 'none'
            });
            TweenMax.to(this.movie,0.5,{
                opacity: 1
            });
            youtube.play('p-madeinjapan__omotenashi-movie-player');
            this.ytFlg = true;
        };

    }


    render(mouse){

        if (youtube.yt['p-madeinjapan__omotenashi-movie-player'] === 0) {
            TweenMax.to([this.image,this.icon],0.5,{
                opacity:1,
                display: 'block'
            });
            TweenMax.to(this.movie,0.5,{
                opacity: 0
            });
            this.ytFlg = false
        }


    }
    resize(_w,_h,_display){

    }

    modal(type){

    }

}
